// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"377":"7b83d909","563":"c8e01d19","834":"0251dd13"}[chunkId] + ".chunk.css";
};